import { TiLocale } from "../types";
import useTiMaxStore from "../hooks/useTiMaxStore";
const getLogo = (color = "black") => {
  const { locale } = useTiMaxStore.getState();
  return locale === TiLocale.ZH_CN ? `https://webcdn.starcharge.com/resources/logo/2411/${color}.svg` : `https://webcdn.starcharge.com/resources/logo/2411/international/${color}.svg`;
};
export {
  getLogo
};
